import React from 'react'
import PropTypes from 'prop-types'

import { Like, Paper, Leaf } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDeleteModal: false
    }
  }

  decrementQuantity() {
    const { elm, change } = this.props
    var quantity = elm?.quantity - 1
    change( elm?.key, quantity > 0 ? quantity : 1 )
  }

  incrementQuantity() {
    const { elm, change } = this.props
    var quantity = elm?.quantity + 1
    change( elm?.key, quantity < 99 ? quantity : 99 )
  }

  openDeleteModal() {
    this.setState({ showDeleteModal: true })
  }

  closeDeleteModal() {
    this.setState({ showDeleteModal: false })
  }

  confirmDelete() {
    const { elm, change } = this.props
    change( elm?.key, 0 )
    this.closeDeleteModal()
  }

  render() {
    const { elm, k, open } = this.props
    const { showDeleteModal } = this.state

    const cartExtras = (elm?.ingredients || []).filter( ingredient => !ingredient?.anti )
    const cartAntis = (elm?.ingredients || []).filter( ingredient => ingredient?.anti )

    return (
      <>
        <div key={k} className='mb-[15px] leading-[100%] relative'>
          <div className='w-[100%] bg-white rounded-[25px] flex gap-[10px]'>
            {elm?.image != '' &&
              <div onClick={() => open( elm?.id )} className='flex-none relative'>
                <img 
                  className='w-[101px] h-[auto]' 
                  src={elm?.image} 
                  alt={elm?.pagetitle} 
                  width="101" 
                  height="64" 
                />
                {elm?.metka?.name != `` &&
                  <div
                    style={{ backgroundColor: elm?.metka?.color }}
                    className='absolute h-[20px] rounded-full px-[10px] bottom-0 left-0 metka-shadow text-white text-[10px] flex items-center'
                  >
                    {elm?.metka?.name}
                  </div>
                }
              </div>
            }
            <div className='flex-1'>
              <div onClick={() => open( elm?.id )} className='text-black text-[18px] font-medium mb-[5px]'>
                {elm?.pagetitle}
              </div>
              <div onClick={() => open( elm?.id )} className='text-[14px] text-[#00000099] mb-[8px] line-clamp-2'>{elm?.introtext}</div>
              {(cartExtras.length > 0 || cartAntis.length > 0) &&
                <div onClick={() => open( elm?.id )} className='text-[14px] text-[#00000099] mb-[8px]'>
                  {cartExtras.length > 0 &&
                    <>
                      <b>Доп. ингредиенты:</b><br />
                      {cartExtras.map(( ingredient, k ) => (
                        <>{k > 0 && <>, </>}{ingredient?.name} x{ingredient?.count}</>
                      ))}
                    </>
                  }
                  {cartExtras.length > 0 && cartAntis.length > 0 && <br />}
                  {cartAntis.length > 0 &&
                    <>
                      <b>Убрать:</b><br />
                      {cartAntis.map(( ingredient, k ) => (
                        <>{k > 0 && <>, </>}{ingredient?.name}</>
                      ))}
                    </>
                  }
                </div>
              }
              <div className='flex items-center w-[100%] gap-[10px]'>
                <div className='flex rounded-[35px] bg-[#F6F6F6] h-[35px] w-[126px] items-center justify-between p-[5px]'>
                  <button 
                    onClick={() => this.decrementQuantity()}
                    className="w-[20px] h-[30px] flex items-center justify-center"
                    disabled={elm?.quantity <= 1}
                  >
                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path 
                        d="M1 1L11.5 1" 
                        stroke={elm?.quantity <= 1 ? "#C9C9C9" : "black"} 
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                  <div className='text-[16px] font-normal text-center'>
                    {elm?.quantity} шт
                  </div>
                  <button 
                    onClick={() => this.incrementQuantity()}
                    className="w-[20px] h-[30px] flex items-center justify-center"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.24512 1V11.5" stroke="black" strokeLinecap="round"/>
                      <path d="M1 6.25488L11.5 6.25488" stroke="black" strokeLinecap="round"/>
                    </svg>
                  </button>
                </div>
                <div className='text-black text-[16px] font-medium whitespace-nowrap'>
                  {elm?.total != elm?.discount_total ?
                    <><span className="line-through text-black/60">{elm?.total}</span> {elm?.discount_total} ₽</>
                  :
                    <>{elm?.total} ₽</>
                  }
                </div>
                <div onClick={() => this.openDeleteModal()} className='ml-auto cursor-pointer flex rounded-[30px] bg-[#F6F6F6] h-[30px] w-[30px] items-center justify-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14 3.987a67.801 67.801 0 0 0-6.68-.334c-1.32 0-2.64.067-3.96.2L2 3.987M5.668 3.313l.147-.873C5.92 1.807 6 1.333 7.128 1.333h1.747c1.126 0 1.213.5 1.313 1.114l.147.866M12.567 6.093l-.433 6.713c-.074 1.047-.134 1.86-1.994 1.86H5.86c-1.86 0-1.92-.813-1.993-1.86l-.433-6.713M6.887 11h2.22M6.332 8.333h3.333"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Модальное окно подтверждения удаления */}
        {showDeleteModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-3xl p-6 max-w-md w-full mx-auto">
              <div className="text-center">
                <div className="mx-auto w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Удалить из корзины?
                </h3>
                
                <p className="text-gray-600 mb-6">
                  {elm?.pagetitle} будет удален из вашего заказа
                </p>

                <div className="flex gap-3">
                  <button
                    onClick={() => this.closeDeleteModal()}
                    className="flex-1 py-3 px-4 border border-gray-300 text-gray-700 rounded-2xl font-medium hover:bg-gray-50 transition-colors"
                  >
                    Отмена
                  </button>
                  <button
                    onClick={() => this.confirmDelete()}
                    className="flex-1 py-3 px-4 bg-red-500 text-white rounded-2xl font-medium hover:bg-red-600 transition-colors"
                  >
                    Удалить
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

Main.propTypes = {
  elm: PropTypes.object,
  k: PropTypes.number,
  change: PropTypes.func,
  open: PropTypes.func
}

export default Main